/**
 * Labstep
 *
 * @module components/ProtocolValue/Variable/Action/Container
 * @desc Bulk Set Items
 */

import { ProtocolValueVariableActionSetItems } from 'labstep-web/components/ProtocolValue/Variable/Action/SetItems';
import { ProtocolValueVariableActionSetItemsContainer } from 'labstep-web/components/ProtocolValue/Variable/Action/SetItems/Container';
import { ICONS } from 'labstep-web/constants/icons';
import { Flex } from 'labstep-web/core/Flex';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import type React from 'react';
import styles from './styles.module.scss';
import type { GridProtocolValueVariableProps } from './types';

export const ProtocolValueVariableActionContainer: React.FC<
  GridProtocolValueVariableProps
> = ({ protocolValue }) => (
  <Flex className={styles.container} column grow shrink={false}>
    <ProtocolValueVariableActionSetItemsContainer>
      {({ disabled, ...containerProps }): React.ReactElement => (
        <ProtocolValueVariableActionSetItems
          {...containerProps}
          protocolValueTemplate={protocolValue}
          actionComponentProps={{
            type: 'button',
            text: `Bulk Select ${ResourceItem.getHumanReadableEntityName(
              true,
              true,
            )}`,
            showIcon: true,
            icon: ICONS.resource_item.primary,
            elementProps: {
              size: 'large',
              primary: true,
              basic: true,
              fluid: true,
              disabled,
            },
          }}
        />
      )}
    </ProtocolValueVariableActionSetItemsContainer>
  </Flex>
);
